export const namespaced = true

export const state = () => ({
  is_whitelabel: false,
  name: null,
  logo: null,
  favicon: null,
  no_result_image: null,
  auth_bg_color: null,
  auth_bg_image: null,
  primary_color: null,
  secondary_color: null,
  header_color: null,
  auth_homepage_url: null,
  auth_bg_size: null,
  auth_bg_repeat: null,
  auth_bg_position: null,
})

export const getters = {
  is_whitelabel: (state) => state.is_whitelabel,
  name: (state) => state.name,
  logo: (state) => state.logo,
  favicon: (state) => state.favicon,
  no_result_image: (state) => state.no_result_image,
  auth_bg_color: (state) => state.auth_bg_color,
  auth_bg_image: (state) => state.auth_bg_image,
  primary_color: (state) => state.primary_color,
  secondary_color: (state) => state.secondary_color,
  header_color: (state) => state.header_color,
  auth_homepage_url: (state) => state.auth_homepage_url,
  auth_bg_size: (state) => state.auth_bg_size,
  auth_bg_repeat: (state) => state.auth_bg_repeat,
  auth_bg_position: (state) => state.auth_bg_position,
}

export const mutations = {
  INIT(state, data) {
    state.is_whitelabel = !!data.is_whitelabel
    state.name = data.name || null
    state.logo = data.logo || null
    state.favicon = data.favicon || null
    state.no_result_image = data.no_result_image || null
    state.auth_bg_color = data.auth_bg_color || null
    state.auth_bg_image = data.auth_bg_image || null
    state.primary_color = data.primary_color || null
    state.secondary_color = data.secondary_color || null
    state.header_color = data.header_color || null
    state.auth_homepage_url = data.auth_homepage_url || null
    state.auth_bg_size = data.auth_bg_size || null
    state.auth_bg_repeat = data.auth_bg_repeat || null
    state.auth_bg_position = data.auth_bg_position || null
  },
}
